import { createSlice } from '@reduxjs/toolkit';

export const commonSlice = createSlice({
  name: 'common',
  initialState: {
    isOpenStandAloneModal: false,
    standAloneData: null,
    standAloneLinkItemData: null,
    isLoadingStore: null,
    storeList: [],
    totalCountStoreList: 0,
    blogList: [],
    isLoadingBlog: null,
    soloAppsList: [],
    singlePagesList: [],

    photosList: null,
    videosList: null,
    musicList: null,
    filesList: null,

    isOpenManagePostsModal: false,
    isOpenManageStoreModal: false,
    activeTab: 'Content',

    isFullWidthStore: false,
    isOpenAddBlockModal: false,
    activeMobileViewLinkInBio: 'preview',

    isLoadingMyPages: false,
    activeBlogItem: null,

    isOpenManageTabsModal: false,
    isOpenAddPageModal: false,
    activeTypeTab: 'content',
    pendingHeaderStatusId: null,
    pendingHeaderActiveView: null,
    pendingHighlightItemId: null,
    pendingEditItem: null,
    pendingExpandHeading: false,
    pendingCreateAppSlug: null,
    isPreviewLiveMode: false,
    isBlockSelectMode: false,
    selectedBlockUids: [],
    targetInsertUid: null,
    isEditorCollapsed: false,
    isBlockCatalogOpen: false,
    pendingDropBlockType: null,
    dropHover: { active: false, targetUid: null },
  },
  reducers: {
    commonUpdateIsOpenStandAloneModal: (state, action) => {
      state.isOpenStandAloneModal = action.payload;
      if (!action.payload) {
        state.standAloneLinkItemData = null;
      }
    },

    commonUpdateStandAloneData: (state, action) => {
      state.standAloneData = action.payload;
    },
    commonUpdateStandAloneLinkItemData: (state, action) => {
      state.standAloneLinkItemData = action.payload;
    },
    commonUpdateStoreList: (state, action) => {
      state.storeList = action.payload;
    },
    commonUpdatePhotosList: (state, action) => {
      state.photosList = action.payload;
    },
    commonUpdateVideosList: (state, action) => {
      state.videosList = action.payload;
    },
    commonUpdateMusicList: (state, action) => {
      state.musicList = action.payload;
    },
    commonUpdateFilesList: (state, action) => {
      state.filesList = action.payload;
    },
    commonUpdateTotalCountStoreList: (state, action) => {
      state.totalCountStoreList = action.payload;
    },
    commonUpdateBlogList: (state, action) => {
      state.blogList = action.payload;
    },
    commonUpdateSoloAppsList: (state, action) => {
      state.soloAppsList = action.payload;
    },
    commonUpdateSinglePagesList: (state, action) => {
      state.singlePagesList = action.payload;
    },
    commonUpdateIsLoadingStore: (state, action) => {
      state.isLoadingStore = action.payload;
    },
    commonUpdateIsLoadingBlog: (state, action) => {
      state.isLoadingBlog = action.payload;
    },
    commonUpdateIsOpenManagePostsModal: (state, action) => {
      state.isOpenManagePostsModal = action.payload;
    },
    commonUpdateIsOpenManageStoreModal: (state, action) => {
      state.isOpenManageStoreModal = action.payload;
    },
    commonUpdateActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    commonUpdateIsFullWidthStore: (state, action) => {
      state.isFullWidthStore = action.payload;
    },
    commonUpdateIsOpenAddBlockModal: (state, action) => {
      state.isOpenAddBlockModal = action.payload;
    },
    commonUpdateActiveMobileViewLinkInBio: (state, action) => {
      state.activeMobileViewLinkInBio = action.payload;
    },
    commonUpdateIsLoadingMyPages: (state, action) => {
      state.isLoadingMyPages = action.payload;
    },
    commonUpdateActiveBlogItem: (state, action) => {
      state.activeBlogItem = action.payload;
    },

    commonUpdateIsOpenManageTabsModal: (state, action) => {
      state.isOpenManageTabsModal = action.payload;
    },
    commonUpdateIsOpenAddPageModal: (state, action) => {
      state.isOpenAddPageModal = action.payload;
    },
    commonUpdateActiveTypeTab: (state, action) => {
      state.activeTypeTab = action.payload;
    },
    commonUpdatePendingHeaderStatusId: (state, action) => {
      state.pendingHeaderStatusId = action.payload;
    },
    commonUpdatePendingHeaderActiveView: (state, action) => {
      state.pendingHeaderActiveView = action.payload;
    },
    commonUpdatePendingHighlightItemId: (state, action) => {
      state.pendingHighlightItemId = action.payload;
    },
    commonUpdatePendingEditItem: (state, action) => {
      state.pendingEditItem = action.payload;
    },
    commonUpdatePendingExpandHeading: (state, action) => {
      state.pendingExpandHeading = action.payload;
    },
    commonUpdateIsPreviewLiveMode: (state, action) => {
      state.isPreviewLiveMode = action.payload;
    },
    commonUpdatePendingCreateAppSlug: (state, action) => {
      state.pendingCreateAppSlug = action.payload;
    },
    commonSetIsBlockSelectMode: (state, action) => {
      state.isBlockSelectMode = action.payload;
      if (!action.payload) {
        state.selectedBlockUids = [];
      }
    },
    commonToggleSelectedBlockUid: (state, action) => {
      const uid = action.payload;
      if (state.selectedBlockUids.includes(uid)) {
        state.selectedBlockUids = state.selectedBlockUids.filter((u) => u !== uid);
      } else {
        state.selectedBlockUids.push(uid);
      }
    },
    commonSetSelectedBlockUids: (state, action) => {
      state.selectedBlockUids = action.payload;
    },
    commonClearSelectedBlockUids: (state) => {
      state.selectedBlockUids = [];
    },
    commonUpdateTargetInsertUid: (state, action) => {
      state.targetInsertUid = action.payload;
    },
    commonToggleEditorCollapsed: (state) => {
      state.isEditorCollapsed = !state.isEditorCollapsed;
    },
    commonSetEditorCollapsed: (state, action) => {
      state.isEditorCollapsed = action.payload;
    },
    commonSetBlockCatalogOpen: (state, action) => {
      state.isBlockCatalogOpen = action.payload;
    },
    commonSetPendingDropBlockType: (state, action) => {
      state.pendingDropBlockType = action.payload;
    },
    commonSetDropHover: (state, action) => {
      state.dropHover = action.payload;
    },
  },
});

export const {
  commonUpdateIsOpenStandAloneModal,
  commonUpdateStandAloneData,
  commonUpdateStandAloneLinkItemData,
  commonUpdateStoreList,
  commonUpdatePhotosList,
  commonUpdateVideosList,
  commonUpdateMusicList,
  commonUpdateFilesList,
  commonUpdateBlogList,
  commonUpdateSoloAppsList,
  commonUpdateSinglePagesList,
  commonUpdateIsLoadingStore,
  commonUpdateIsLoadingBlog,
  commonUpdateIsOpenManagePostsModal,
  commonUpdateIsOpenManageStoreModal,
  commonUpdateActiveTab,
  commonUpdateIsFullWidthStore,
  commonUpdateIsOpenAddBlockModal,
  commonUpdateActiveMobileViewLinkInBio,
  commonUpdateIsLoadingMyPages,
  commonUpdateTotalCountStoreList,
  commonUpdateActiveBlogItem,
  commonUpdateIsOpenManageTabsModal,
  commonUpdateIsOpenAddPageModal,
  commonUpdateActiveTypeTab,
  commonUpdatePendingHeaderStatusId,
  commonUpdatePendingHeaderActiveView,
  commonUpdatePendingHighlightItemId,
  commonUpdatePendingEditItem,
  commonUpdatePendingExpandHeading,
  commonUpdateIsPreviewLiveMode,
  commonUpdatePendingCreateAppSlug,
  commonSetIsBlockSelectMode,
  commonToggleSelectedBlockUid,
  commonSetSelectedBlockUids,
  commonClearSelectedBlockUids,
  commonUpdateTargetInsertUid,
  commonToggleEditorCollapsed,
  commonSetEditorCollapsed,
  commonSetBlockCatalogOpen,
  commonSetPendingDropBlockType,
  commonSetDropHover,
} = commonSlice.actions;

export const selectCommonIsOpenStandAloneModal = (state) => state.common.isOpenStandAloneModal;
export const selectCommonStandAloneData = (state) => state.common.standAloneData;
export const selectCommonStandAloneLinkItemData = (state) => state.common.standAloneLinkItemData;
export const selectCommonStoreList = (state) => state.common.storeList;
export const selectCommonTotalCountStoreList = (state) => state.common.totalCountStoreList;
export const selectCommonBlogList = (state) => state.common.blogList;
export const selectCommonSoloAppsList = (state) => state.common.soloAppsList;
export const selectCommonSinglePagesList = (state) => state.common.singlePagesList;

export const selectCommonPhotosList = (state) => state.common.photosList;
export const selectCommonVideosList = (state) => state.common.videosList;
export const selectCommonMusicList = (state) => state.common.musicList;
export const selectCommonFilesList = (state) => state.common.filesList;

export const selectCommonIsLoadingStore = (state) => state.common.isLoadingStore;
export const selectCommonIsLoadingBlog = (state) => state.common.isLoadingBlog;

export const selectCommonIsOpenManagePostsModal = (state) => state.common.isOpenManagePostsModal;
export const selectCommonIsOpenManageStoreModal = (state) => state.common.isOpenManageStoreModal;

export const selectCommonActiveTab = (state) => state.common.activeTab;

export const selectCommonIsFullWidthStore = (state) => state.common.isFullWidthStore;
export const selectCommonIsOpenAddBlockModal = (state) => state.common.isOpenAddBlockModal;

export const selectCommonActiveMobileViewLinkInBio = (state) => state.common.activeMobileViewLinkInBio;

export const selectCommonIsLoadingMyPages = (state) => state.common.isLoadingMyPages;

export const selectCommonActiveBlogItem = (state) => state.common.activeBlogItem;

export const selectCommonIsOpenManageTabsModal = (state) => state.common.isOpenManageTabsModal;
export const selectCommonIsOpenAddPageModal = (state) => state.common.isOpenAddPageModal;

export const selectCommonActiveTypeTab = (state) => state.common.activeTypeTab;
export const selectCommonPendingHeaderStatusId = (state) => state.common.pendingHeaderStatusId;
export const selectCommonPendingHeaderActiveView = (state) => state.common.pendingHeaderActiveView;
export const selectCommonPendingHighlightItemId = (state) => state.common.pendingHighlightItemId;
export const selectCommonPendingEditItem = (state) => state.common.pendingEditItem;
export const selectCommonPendingExpandHeading = (state) => state.common.pendingExpandHeading;
export const selectCommonIsPreviewLiveMode = (state) => state.common.isPreviewLiveMode;
export const selectCommonPendingCreateAppSlug = (state) => state.common.pendingCreateAppSlug;

export const selectCommonIsBlockSelectMode = (state) => state.common.isBlockSelectMode;
export const selectCommonSelectedBlockUids = (state) => state.common.selectedBlockUids;
export const selectCommonTargetInsertUid = (state) => state.common.targetInsertUid;
export const selectCommonIsEditorCollapsed = (state) => state.common.isEditorCollapsed;
export const selectCommonIsBlockCatalogOpen = (state) => state.common.isBlockCatalogOpen;
export const selectCommonPendingDropBlockType = (state) => state.common.pendingDropBlockType;
export const selectCommonDropHover = (state) => state.common.dropHover;

export default commonSlice.reducer;
